import { makeStyles } from '@mui/styles';
const contentRowStyles = makeStyles(() => ({
    contentRow: {
        display: 'flex',
        width: '100%',
        padding: '5px 0',
        alignItems: 'center',
    },
    contentLeft: {
        width: '60%',
        textAlign: 'left',
        paddingRight: '5px',
        fontWeight: 700,
    },
    contentRight: {
        width: '40%',
        textAlign: 'right',
        paddingLeft: '5px',
        marginRight: 32,
    },
}), { name: 'Common_ContentRow' });
export default contentRowStyles;
//# sourceMappingURL=contentRow.styles.js.map